import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths, checkpoints } from 'src/constants';
import { useIntlMessages, useCheckpoint } from 'src/hooks';

import { Container } from './components';

const ReadTogetherCollections = ({
  getCollections,
  getSpeechSoundById,
  hasLoaded,
  pageCount,
  readTogetherCollections,
  readTogetherCurrency,
  student,
  studentSpeechSound,
}) => {
  const messages = useIntlMessages();

  useCheckpoint(checkpoints.FIRST_TIME_ON_READ_TOGETHER, hasLoaded);

  return (
    <Container
      collectionsPath={paths.READ_TOGETHER}
      currency={readTogetherCurrency}
      getCollections={getCollections}
      getSpeechSoundById={getSpeechSoundById}
      hasLoaded={hasLoaded}
      items={readTogetherCollections}
      levelsPath={paths.READ_TOGETHER_LEVELS}
      pageCount={pageCount}
      student={student}
      studentSpeechSound={studentSpeechSound}
      title={messages.game.readTogether}
    />
  );
};

ReadTogetherCollections.propTypes = {
  getCollections: PropTypes.func.isRequired,
  getSpeechSoundById: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  pageCount: PropTypes.number.isRequired,
  readTogetherCollections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  readTogetherCurrency: PropTypes.shape({}).isRequired,
  student: PropTypes.shape({}).isRequired,
  studentSpeechSound: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.readTogetherCollections.getHasLoaded(state),
  readTogetherCurrency: selectors.readTogetherCollections.getCurrencyData(
    state
  ),
  readTogetherCollections: selectors.readTogetherCollections.getCollectionsData(
    state
  ),
  pageCount: selectors.readTogetherCollections.getPageCount(state),
  student: selectors.authentication.getStudent(state),
  studentSpeechSound: selectors.speechSounds.getSpeechSound(state),
});

const mapDispatchToProps = {
  ...actions.readTogether,
  ...actions.speechSounds,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(ReadTogetherCollections);
